module.exports = __webpack_public_path__ + "static/media/map.e728580c.png";